import { Component, OnInit } from '@angular/core';
import {Message, MessageService} from 'primeng/api';

import { environment } from '@env/environment';
import { GrowlService } from '@app/core/growl/growl.service';
import { GrowlType } from '@app/shared/enums/growl-type.enum';


@Component({
  selector: 'app-growl',
  templateUrl: './growl.component.html',
  styleUrls: ['./growl.component.css'],
  providers: [MessageService]
})
export class GrowlComponent implements OnInit {
  key: string;

  constructor (private growl: GrowlService, private messageService: MessageService) {
    growl.added.subscribe(msg => {
      let life = environment['growlNormalTimeout'];
        if (msg.severity === GrowlType.Error) {
          life = environment['growlErrorTimeout'];
        } else if (msg.severity === GrowlType.Warn) {
          life = environment['growlWarnTimeout'];
        } else if (msg.severity === GrowlType.Info) {
          life = environment['growlInfoTimeout'];
        } else if (msg.severity === GrowlType.Success) {
          life = environment['growlNormalTimeout'];
        } else if (msg.severity === GrowlType.SuccessLong) {
          life = environment['growlNormalLongerTimeout'];
        }
      this.messageService.add({severity:msg.severity, summary: msg.summary, detail: msg.detail, life: life});
    })
  }

  ngOnInit() {
  }
}
